module.exports = __webpack_public_path__ + "static/media/iv-newseum.f99a8311.pdf";